import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextFormattingToggleButton from './textFormattingToggleButton';
import TextFormattingDropDown from './textFormattingDropDown';
import classNames from 'classnames';
function TextFormattingToggleButtonWithDropDown(props) {
  return /*#__PURE__*/React.createElement("span", null, props.value ? null : /*#__PURE__*/React.createElement(TextFormattingToggleButton, _.assign({}, {
    key: 'toggleOff'
  }, props)), props.value ? /*#__PURE__*/React.createElement(TextFormattingDropDown, {
    value: props.value,
    onChange: props.onChange,
    options: props.options,
    hasArrowIcon: false,
    callOnChangeAnyway: true,
    className: classNames('text-formatting-toggle-button text-formatting-button-with-dropdown', {
      'selected-has-background': props.hasBackgroundWhenSelected
    }),
    optionsContainerClassName: "text-formatting-button-with-dropdown-options",
    tooltipContent: props.tooltipContent,
    shouldTranslate: props.shouldTranslate
  }) : null);
}
TextFormattingToggleButtonWithDropDown.displayName = displayNames.TEXT_FORMATTING_TOGGLE_BUTTON;
TextFormattingToggleButtonWithDropDown.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    content: PropTypes.any
  })).isRequired,
  hasBackgroundWhenSelected: PropTypes.bool,
  tooltipContent: PropTypes.string
};
TextFormattingToggleButtonWithDropDown.defaultProps = {
  disabled: false
};
export default compose(TextFormattingToggleButtonWithDropDown);